import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalDateService } from './services/global-date.service';
// import { GlobalDateService } from '../../@shared/services/service/global-date.service';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  constructor(private dateService: GlobalDateService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Never mutate FormData / binary bodies — that breaks multipart file uploads.
    if (typeof FormData !== 'undefined' && req.body instanceof FormData) {
      return next.handle(req);
    }
    if (typeof Blob !== 'undefined' && req.body instanceof Blob) {
      return next.handle(req);
    }

    const clonedReq = req.clone({
      body: this.transformDates(req.body)
    });

    return next.handle(clonedReq);
  }

  private transformDates(body: any): any {
    if (!body || typeof body !== 'object') return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return body;
    if (typeof Blob !== 'undefined' && body instanceof Blob) return body;
    if (Array.isArray(body)) {
      return body.map((item) => this.transformDates(item));
    }

    for (const key in body) {
      if (!Object.prototype.hasOwnProperty.call(body, key)) continue;
      if (body[key] instanceof Date) {
        body[key] = this.dateService.toUTC(body[key]);
      } else if (body[key] && typeof body[key] === 'object') {
        body[key] = this.transformDates(body[key]);
      }
    }
    return body;
  }
}
